module.exports = __webpack_public_path__ + "static/media/09.80da5a34.jpg";